var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFive2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 18.0107L16.6414 15.5961C19.0942 14.1881 19.9437 11.0479 18.5354 8.59599C17.1272 6.14337 13.9859 5.2941 11.5337 6.70237L10.1468 4.28771C11.9803 3.23549 14.114 2.9601 16.154 3.51175C18.1945 4.06341 19.8982 5.37685 20.9507 7.20959C23.1237 10.9928 21.8126 15.8384 18.0281 18.0109L18.0283 18.0107Z",
    fill: "#BFFF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9251 14.9727C7.23138 14.9727 6.53346 14.8807 5.84587 14.6947C3.80532 14.1431 2.10166 12.8296 1.04918 10.9969C-1.1235 7.21331 0.187636 2.36807 3.97175 0.195557L5.35866 2.61022C2.90615 4.01814 2.05668 7.15837 3.46459 9.61029C4.8732 12.0629 8.01417 12.9115 10.4663 11.5039L11.8532 13.9186C10.6377 14.6163 9.29013 14.9725 7.92527 14.9725L7.9251 14.9727Z",
    fill: "#BFFF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1268 9.81822C8.47799 9.81822 9.57335 8.72312 9.57335 7.37225C9.57335 6.02137 8.47799 4.92627 7.1268 4.92627C5.7756 4.92627 4.68024 6.02137 4.68024 7.37225C4.68024 8.72312 5.7756 9.81822 7.1268 9.81822Z",
    fill: "#BFFF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7172 12.8519C16.0684 12.8519 17.1637 11.7568 17.1637 10.4059C17.1637 9.05506 16.0684 7.95996 14.7172 7.95996C13.366 7.95996 12.2706 9.05506 12.2706 10.4059C12.2706 11.7568 13.366 12.8519 14.7172 12.8519Z",
    fill: "#BFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive2);
export default __webpack_public_path__ + "static/media/five2.b3d98ae23ba7a921a6da680871642404.svg";
export { ForwardRef as ReactComponent };